import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'aw-subscription-payment-step',
  imports: [CommonModule],
  templateUrl: './subscription-payment-step.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionPaymentStepComponent {}
